import { fonts } from '../theme/variables';

export default (theme) => ({
  dialog: {
    background: theme.colorPalette.red_20,
    width: 600,
    minHeight: 365,
    borderRadius: 6,
    display: 'flex',
    position: 'relative'
  },
  body: {
    flex: 1,
    padding: 48,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between'
  },
  title: {
    fontSize: 42,
    marginBottom: 24,
    fontWeight: 200,
    display: 'block',
    color: '#fff'
  },
  message: {
    display: 'block',
    color: theme.colorPalette.beige_10,
    fontSize: 20,
    lineHeight: 1.5,
    fontFamily: fonts.FrankRuhlLibre
  },
  closeButton: {
    position: 'absolute',
    top: 4,
    right: 4,
    padding: 8
  },
  button: {
    width: 288,
    alignSelf: 'flex-end'
  }
});
